import { render, staticRenderFns } from "./TranslatorContactInformationForm.vue?vue&type=template&id=05c6c634&"
import script from "./TranslatorContactInformationForm.vue?vue&type=script&lang=js&"
export * from "./TranslatorContactInformationForm.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorContactInformationForm.vue?vue&type=style&index=0&id=05c6c634&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports